<app-navbar></app-navbar>
<div class="referral-card">
  <h2 class="title">Refer a patient</h2>

  <label>Patient First Name<span class="req">*</span></label>
  <input class="input" [(ngModel)]="form.firstname" maxlength="20" />
  <div class="invalid" *ngIf="submitted && !form.firstname.trim()">Please enter first name</div>

  <label>Patient Middle Name</label>
  <input class="input" [(ngModel)]="form.middlename" maxlength="20" />

  <label>Patient Last Name<span class="req">*</span></label>
  <input class="input" [(ngModel)]="form.lastname" maxlength="20" />
  <div class="invalid" *ngIf="submitted && !form.lastname.trim()">Please enter last name</div>

  <div class="row" style="margin-top: 10px;">
    <div class="col">
      <label>Birth Date<span class="req">*</span></label>
      <app-calendar
        label=""
        placeholder="MM-DD-YYYY"
        [required]="true"
        [(ngModel)]="form.dob"
      ></app-calendar>
      <div class="invalid" *ngIf="submitted && !form.dob">Please enter birth date</div>
    </div>
    <div class="col">
      <label>Birth Sex<span class="req">*</span></label>
      <select id="birthSexSelect" class="input" [(ngModel)]="form.birthsex">
        <option value="">---Select---</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="Prefer not to say">Prefer not to say</option>
      </select>
    </div>
  </div>

  <label style="margin-top: 10px;">Patient Email<span class="req">*</span></label>
  <input class="input" [(ngModel)]="form.email" type="email" maxlength="40" />
  <div class="invalid" *ngIf="submitted && !form.email">Please enter email</div>

  <label>Patient Phone Number<span class="req">*</span></label>
  <input class="input" [value]="form.phone" (input)="formatPhone($event)" />
  <div class="invalid" *ngIf="submitted && !form.phone">Please enter phone number</div>

  <label>Street Address</label>
  <input class="input" [(ngModel)]="form.address" maxlength="40" />

  <div class="row">
    <div class="col">
      <label>City</label>
      <input class="input" [(ngModel)]="form.city" />
    </div>
    <div class="col">
      <label>Zip</label>
      <input class="input" [(ngModel)]="form.zip" />
    </div>
  </div>

<label>State<span class="req">*</span></label>
<select id="stateSelect" class="input selectlike" [(ngModel)]="form.state">
    <option value="">State</option>
    <option *ngFor="let s of stateOptions" [value]="s">{{ s }}</option>
  </select>
  <div class="invalid" *ngIf="submitted && !form.state">Please select your state</div>

  <h3 class="subtitle">Referring Provider Details</h3>
  <label>First Name</label>
  <input class="input" [(ngModel)]="form.submitterFirstName" />
  <label>Last Name</label>
  <input class="input" [(ngModel)]="form.submitterLastName" />
  <label>Practice/Organization</label>
  <select class="input selectlike" [ngModel]="otherCompany ? 'Other' : form.affiliatedCompany" (ngModelChange)="onCompanyChange($event)">
    <option value="">Select Practice/Organization</option>
    <option *ngFor="let c of companies" [value]="c">{{ c }}</option>
    <option value="Other">Other</option>
  </select>
  <div *ngIf="otherCompany" class="mt-2">
    <input class="input" [(ngModel)]="form.affiliatedCompany" placeholder="Enter your practice/organization" />
  </div>
  <label>Contact Number</label>
  <input class="input" [value]="form.submitterPhone" (input)="formatSubmitterPhone($event)" />
  <label>Email</label>
  <input class="input" [(ngModel)]="form.Submitteremail" type="email" />
  <label>Fax</label>
  <input class="input" [(ngModel)]="form.Submitterfax" />
  <label>Reason for Referral</label>
  <input class="input" [(ngModel)]="form.reasonForReferral" />

  <label class="consent">
    <input type="checkbox" [(ngModel)]="form.smsConsent" />
    <span>By checking this box, I consent to receive text messages related to information, appointments and practice updates from Animo Sano Psychiatry, PLLC. You can reply "STOP" at any time to opt-out. Message and data rates may apply. Message frequency may vary; text HELP to (919) 391-7202 for assistance. For more information, please refer to our <a href="https://animosanopsychiatry.com/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a> and <a href="https://animosanopsychiatry.com/privacy-policy/#sms-tc" target="_blank" rel="noopener noreferrer">SMS Terms and Conditions</a> on our website.</span>
  </label>
  <div class="invalid" *ngIf="submitted && !form.smsConsent">Please accept the consent to proceed</div>

  <div class="actions">
    <button class="btn primary next justify-self-end" [disabled]="loading" (click)="onNext()">Next</button>
  </div>
  <app-loader *ngIf="loading" [fullscreen]="true" [message]="'Submitting referral'" ></app-loader>
</div>

<div class="s65-backdrop" *ngIf="show65PlusModal">
  <div class="s65-modal">
    <div class="s65-header">
      <span class="s65-title">Screening Questions for Adults 65+</span>
      <button type="button" class="s65-close" (click)="close65PlusModal()">✕</button>
    </div>
    <div class="s65-body">
      <div class="s65-question">
        <div class="s65-question-title">1. Cognitive Diagnosis Screening</div>
        <div class="s65-question-text">Are you seeking care specifically for memory loss, dementia, or a neurocognitive condition?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-cognitive" [value]="true" [(ngModel)]="screening65Plus.cognitiveDiagnosis">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-cognitive" [value]="false" [(ngModel)]="screening65Plus.cognitiveDiagnosis">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.cognitiveDiagnosis === true">
          Our psychiatry services are not able to evaluate or treat memory loss, dementia, or neurocognitive conditions. We recommend speaking with your primary care provider for a referral to a specialist who can best support your needs.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">2. Medication Independence</div>
        <div class="s65-question-text">Is anyone else (nurse or other medical professional) responsible for administering your medications?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-medication" [value]="true" [(ngModel)]="screening65Plus.medicationDependence">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-medication" [value]="false" [(ngModel)]="screening65Plus.medicationDependence">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.medicationDependence === true">
          Our telehealth model requires patients to independently manage their medications; we may not be the right fit for your current situation. We encourage you to speak with your existing care team to help find the right support.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">3. Clinical Decision-Making Authority</div>
        <div class="s65-question-text">Is there a Power of Attorney (POA) or a Healthcare Proxy who makes medical decisions on your behalf?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-poa" [value]="true" [(ngModel)]="screening65Plus.poaProxy">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-poa" [value]="false" [(ngModel)]="screening65Plus.poaProxy">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.poaProxy === true">
          Our practice requires that patients be able to make their own medical decisions independently. Because a Power of Attorney or Healthcare Proxy is in place for your care, we are unable to proceed with scheduling at this time.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">4. Technology Independence</div>
        <div class="s65-question-text">Do you require assistance using a smartphone, tablet, or computer to complete intake forms and attend video appointments?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-tech" [value]="true" [(ngModel)]="screening65Plus.technologyAssist">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-tech" [value]="false" [(ngModel)]="screening65Plus.technologyAssist">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.technologyAssist === true">
          We are happy to provide technical support. Please call our office before your appointment if you have any question at 919-391-7202.
        </p>
      </div>
    </div>
    <div class="s65-footer">
      <button type="button" class="s65-cancel-btn" (click)="close65PlusModal()">Cancel</button>
      <button type="button" class="s65-submit-btn" [disabled]="!screening65PlusCanProceed" (click)="trackReferralOlderAdultsSeeAvailableSlotsClick(); on65PlusProceed()">Continue</button>
    </div>
  </div>
</div>

<div class="s65-backdrop" *ngIf="show65PlusUncertainModal">
  <div class="s65-modal s65-modal-small">
    <div class="s65-header">
      <span class="s65-title">Screening Questions for Adults 65+</span>
      <button type="button" class="s65-close" (click)="on65PlusUncertainClose()">✕</button>
    </div>
    <div class="s65-body s65-body-small">
      <p class="s65-center-message">
        We are uncertain at this time if a virtual psychiatry appointment would be the best fit for you. Please call our team to discuss your situation and needs further.
        <a href="tel:9193977202" class="s65-phone-number">919-397-7202</a>
      </p>
    </div>
    <div class="s65-footer s65-footer-right">
      <button type="button" class="s65-cancel-btn" (click)="on65PlusUncertainClose()">Close</button>
    </div>
  </div>
</div>

<app-footer></app-footer>


